/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export * from 'ui-permit/shared-components/utils/constants';

export const PREFIX = `HUNTING_PERMIT_`;

// prop path constants
export const GROUP_DETAIL_PASS_TYPE_PROP_PATH = 'GROUP_DETAIL_PASS_TYPE_PROP_PATH';
export const GROUP_DETAIL_PASS_ID_PROP_PATH = 'GROUP_DETAIL_PASS_ID_PROP_PATH';
export const DNR_NUMBER_PROP_PATH = 'DNR_NUMBER_PROP_PATH';

// error messages
export const ERROR_DEFAULT = 'Something went wrong, please try again later.';
export const ERROR_UNAUTHORIZED = 'You are not authorized to access this page.';

export const LOTTERY_STATUS = {
    Displayed: 1,
    Open: 2,
};

export const progressSteps = ['Order Details', 'Review Cart', 'Payment', 'Confirmation'];
